document.addEventListener('DOMContentLoaded', function () {
  const blockquotes = document.querySelectorAll('.article-content blockquote');

  blockquotes.forEach(function (blockquote) {
    blockquote.addEventListener('click', function () {

      const textContent = this.innerText.trim().replace(/\s+/g, ' ');

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(textContent)
          .then(function () {
            showCopiedState(blockquote);
          })
          .catch(function (err) {
            console.error('Failed to copy text: ', err);
            fallbackCopyTextToClipboard(textContent, blockquote);
          });
      } else {
        fallbackCopyTextToClipboard(textContent, blockquote);
      }
    });
  });

  function showCopiedState(element) {
    blockquotes.forEach(function (blockquote) {
      blockquote.classList.remove('copied');
    });

    element.classList.add('copied');
  }

  function fallbackCopyTextToClipboard(text, element) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        showCopiedState(element);
      }
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }
});
